import { render } from "./GeneratePage.vue?vue&type=template&id=03a84c1c&scoped=true"
import script from "./GeneratePage.vue?vue&type=script&lang=js"
export * from "./GeneratePage.vue?vue&type=script&lang=js"

import "./GeneratePage.vue?vue&type=style&index=0&id=03a84c1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a84c1c"]])

export default __exports__